export default "__VITE_ASSET__CIU$MT37__"